<template>
  <div class="cert-card-skeleton">
    <!-- Header -->
    <div class="cert-card-skeleton__header">
      <div class="cert-card-skeleton__header-left">
        <div class="skel skel--icon"></div>
        <div class="skel skel--title"></div>
      </div>
      <div class="skel skel--badge"></div>
    </div>

    <!-- Body -->
    <div class="cert-card-skeleton__body">
      <div class="cert-card-skeleton__grid">
        <div v-for="n in 4" :key="n" class="cert-card-skeleton__item">
          <div class="skel skel--label"></div>
          <div class="skel skel--value"></div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="cert-card-skeleton__footer">
      <div class="skel skel--btn"></div>
      <div class="skel skel--btn"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CertificateCardSkeleton"
}
</script>

<style scoped>
.cert-card-skeleton {
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  margin-bottom: 16px;
  overflow: hidden;
}

/* ── Header ── */
.cert-card-skeleton__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  border-bottom: 1px solid #eef0f3;
}

.cert-card-skeleton__header-left {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* ── Body ── */
.cert-card-skeleton__body {
  padding: 14px 16px;
}

.cert-card-skeleton__grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.cert-card-skeleton__item {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

/* ── Footer ── */
.cert-card-skeleton__footer {
  display: flex;
  gap: 8px;
  padding: 0 16px 14px;
}

/* ── Skeleton shapes ── */
.skel {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 6px;
}

.skel--icon {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  flex-shrink: 0;
}

.skel--title {
  width: 180px;
  height: 16px;
}

.skel--badge {
  width: 56px;
  height: 22px;
  border-radius: 20px;
}

.skel--label {
  width: 70px;
  height: 12px;
}

.skel--value {
  width: 110px;
  height: 14px;
}

.skel--btn {
  flex: 1;
  height: 40px;
  border-radius: 8px;
}

@keyframes shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

/* ── Desktop ── */
@media (min-width: 769px) {
  .cert-card-skeleton {
    border-radius: 12px;
    margin-bottom: 12px;
  }

  .cert-card-skeleton__header {
    padding: 12px 20px;
  }

  .cert-card-skeleton__body {
    padding: 14px 20px;
  }

  .cert-card-skeleton__grid {
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap: 16px;
  }

  .cert-card-skeleton__footer {
    padding: 0 20px 14px;
    max-width: 170px;
    flex-direction: column;
  }

  .skel--title {
    width: 220px;
    height: 15px;
  }

  .skel--btn {
    width: 100%;
    height: 36px;
  }
}

/* ── Mobil ── */
@media (max-width: 768px) {
  .cert-card-skeleton__header {
    padding: 16px;
  }

  .cert-card-skeleton__body {
    padding: 16px;
  }

  .cert-card-skeleton__grid {
    gap: 16px;
  }

  .cert-card-skeleton__footer {
    padding: 0 16px 16px;
  }

  .skel--icon {
    width: 24px;
    height: 24px;
  }

  .skel--title {
    width: 200px;
    height: 18px;
  }

  .skel--btn {
    height: 48px;
    border-radius: 10px;
  }

  .skel--label {
    width: 80px;
    height: 14px;
  }

  .skel--value {
    width: 120px;
    height: 16px;
  }
}

@media (max-width: 480px) {
  .cert-card-skeleton {
    border-radius: 12px;
    margin-bottom: 12px;
  }

  .cert-card-skeleton__header,
  .cert-card-skeleton__body {
    padding-left: 12px;
    padding-right: 12px;
  }

  .cert-card-skeleton__footer {
    padding-left: 12px;
    padding-right: 12px;
  }

  .cert-card-skeleton__grid {
    gap: 12px 8px;
  }
}
</style>
